<template>
    <v-layout wrap>
        <applications-list :bids="bids"></applications-list>
    </v-layout>
</template>

<script>
import ApplicationsList from "../_components/applications_list.vue";
import { mapGetters } from 'vuex';
export default {
  components: {
    ApplicationsList
  },
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      bids: []
    };
  },
  created() {                
    this.$store
      .dispatch("get", "/engagement/user/" + this.user._id)
      .then(res => {
        this.bids = res.engagements;
      });
  }
};
</script>

